import React from 'react';
import { motion } from 'framer-motion';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  message?: string;
  fullScreen?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message = '',
  fullScreen = false,
  className = ''
}) => {
  const spinnerSizes = {
    sm: 24,
    md: 40,
    lg: 56,
    xl: 72
  };

  const containerVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  };

  const spinnerVariants = {
    animate: {
      rotate: 360,
      transition: {
        duration: 1,
        repeat: Infinity,
        ease: "linear" as const
      }
    }
  };

  const dotsVariants = {
    animate: {
      opacity: [0.4, 1, 0.4],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut" as const
      }
    }
  };

  const content = (
    <motion.div
      className={`loading-spinner__container ${fullScreen ? 'loading-spinner__container--fullscreen' : ''} ${className}`}
      variants={containerVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="loading-spinner__content">
        <motion.div
          className={`loading-spinner loading-spinner--${size}`}
          variants={spinnerVariants}
          animate="animate"
          style={{ width: spinnerSizes[size], height: spinnerSizes[size] }}
        >
          <div className="loading-spinner__circle"></div>
        </motion.div>

        {message && (
          <motion.p
            className="loading-spinner__message"
            variants={dotsVariants}
            animate="animate"
          >
            {message}
          </motion.p>
        )}
      </div>
    </motion.div>
  );

  return content;
};

export default LoadingSpinner;
